import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faWhatsapp} from "@fortawesome/free-brands-svg-icons"

const WhatsApp = () => (
    <a href="https://wa.me/527775389070?text=Specialized%20technology%20services"
       className="whatsapp"
       target="_blank">
        <FontAwesomeIcon icon={faWhatsapp}/>
    </a>

);

export default WhatsApp;
